/*
 * @Author: DESKTOP-90MI9K1\admin yangxiong
 * @Date: 2025-02-28 11:53:14
 * @LastEditors: DESKTOP-90MI9K1\admin yangxiong
 * @LastEditTime: 2025-03-10 16:24:43
 * @FilePath: \xypt-vue\src\api\interface\home.js
 * @Description: 
 * 
 * Copyright (c) 2025 by 抠脚老汉, All Rights Reserved. 
 */
import axios from '../api' // 倒入 api
export const home = {
  // 首页滚动通知
  getPageScorllerReportList: params => {
    return axios({
      url: '/huizb-app/reportRecord/getPageScorllerReportList',
      method: 'get',
      base: 'ZBID',
      params
    })
  },
  // 公示公告列表
  cxPublicityList: data => {
    return axios({
      url: '/hui-xypt/cxPublicity/list',
      method: 'post',
      base: 'BASE',
      data
    })
  },
  // 信用排行展示
  selectBidWinOrgInfoByTypeAndSortList: data => {
    return axios({
      url: '/coi/bid/tender/v1/selectBidWinOrgInfoByTypeAndSort',
      method: 'post',
      base: 'CORE',
      data
    })
  },
  // 判断企业是否认证
  checkOrgHasAuthed: data => {
    return axios({
      url: '/huizb-app/approve/checkOrgHasAuthed',
      method: 'post',
      base: 'ZBID',
      data
    })
  },
  // 搜索企业
  searchOrgTYC: data => {
    return axios({
      url: '/huizb-app/orgSearchTYC/searchOrgTYC',
      method: 'post',
      base: 'ZBID',
      hideMsg: true,
      data
    })
  },
  // 信用积分
  selectBaseDetail: params => {
    return axios({
      url: '/huizb-app/orgContent/selectBaseDetail',
      method: 'get',
      base: 'ZBID',
      params
    })
  },
  // 会员费用查询
  selectVipList: data => {
    return axios({
      url: '/huizb-app/myVip/selectVipList',
      method: 'post',
      base: 'ZBID',
      data,
      loading: true
    })
  },
}


export default home
